import React from "react";
import { isMobile } from "react-device-detect";
import { MobileLogin } from "../../components/login/mobile/MobileLogin";
import WebLogin from "../../components/login/web/WebLogin";

export const Login = () => {
  return isMobile ? <MobileLogin /> : <WebLogin />;
};
